import {z} from "zod";

export const accountStatusResponse = z.object({
    id: z.string(),
    active: z.boolean().default(true),
    verified: z.boolean().default(false),
    verified_id: z.string().uuid().nullable(),
    terms_accepted_at: z.date().nullable(),
    terms_version: z.string().nullable(),
    privacy_notice_acknowledged_at: z.date().nullable(),
    privacy_notice_version: z.string().nullable(),
    signup_notification_sent_at: z.date().nullable().optional(),
    verification_notification_sent_at: z.date().nullable().optional(),
    updated_at: z.date(),
    created_at: z.date(),
});

export type AccountStatusResponse = z.infer<typeof accountStatusResponse>;

export const accountStatusEntityResponse = z.object({
    id: z.string(),
    active: z.boolean().default(true),
    verified: z.boolean().default(false),
    verified_id: z.string().uuid().nullable(),
    terms_accepted_at: z.date().nullable(),
    terms_version: z.string().nullable(),
    privacy_notice_acknowledged_at: z.date().nullable(),
    privacy_notice_version: z.string().nullable(),
    signup_notification_sent_at: z.date().nullable().optional(),
    verification_notification_sent_at: z.date().nullable().optional(),
    updated_at: z.date(),
    created_at: z.date(),
});

export type AccountStatusEntityResponse = z.infer<typeof accountStatusEntityResponse>;

export const accountStatusByIdRequest = z.object({
    id: z.string().uuid(),
});

export type AccountStatusByIdRequest = z.infer<typeof accountStatusByIdRequest>;

export const accountStatusUpdateRequest = z.object({
    id: z.string().uuid(),
    data: z.object({
        active: z.boolean(),
    })
});

export type AccountStatusUpdateRequest = z.infer<typeof accountStatusUpdateRequest>;

export const accountStatusLegalAcceptanceUpdateRequest = z.object({
    id: z.string().uuid(),
    data: z.object({
        terms_accepted_at: z.date(),
        terms_version: z.string().min(1),
        privacy_notice_acknowledged_at: z.date(),
        privacy_notice_version: z.string().min(1),
    })
});

export type AccountStatusLegalAcceptanceUpdateRequest = z.infer<typeof accountStatusLegalAcceptanceUpdateRequest>;

export const accountStatusSignupWelcomeEmailRequest = z.object({
    id: z.string().uuid(),
});

export type AccountStatusSignupWelcomeEmailRequest = z.infer<typeof accountStatusSignupWelcomeEmailRequest>;

export const accountStatusSignupWelcomeEmailReleaseRequest = z.object({
    id: z.string().uuid(),
    claimed_at: z.date(),
});

export type AccountStatusSignupWelcomeEmailReleaseRequest = z.infer<typeof accountStatusSignupWelcomeEmailReleaseRequest>;

export const accountStatusVerificationNotificationRequest = z.object({
    id: z.string().uuid(),
});

export type AccountStatusVerificationNotificationRequest = z.infer<typeof accountStatusVerificationNotificationRequest>;

export const accountStatusVerificationNotificationReleaseRequest = z.object({
    id: z.string().uuid(),
    claimed_at: z.date(),
});

export type AccountStatusVerificationNotificationReleaseRequest = z.infer<typeof accountStatusVerificationNotificationReleaseRequest>;

export const accountStatusVerifiedUpdateRequest = z.object({
    id: z.string().uuid(),
    data: z.object({
        verified: z.boolean(),
        verified_id: z.string().uuid(),
    })
});

export type AccountStatusVerifiedUpdateRequest = z.infer<typeof accountStatusVerifiedUpdateRequest>;
